import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  ChangeDetectorRef,
} from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { DatePipe } from '@angular/common';
import { _ } from 'underscore';
import { holidays } from '../../../../../assets/holidays';
import {
  IMyDpOptions,
  IMyDate,
  IMyDateModel,
  IMyInputFieldChanged,
} from 'mydatepicker';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as moment from 'moment-timezone';
import { AdjustTimeService } from 'src/app/questionarie-signup/adjust-time.service';

@Component({
  selector: 'app-r-q7',
  templateUrl: './r-q7.component.html',
  styleUrls: ['./r-q7.component.css', '../residential-question.component.css'],
  providers: [DatePipe],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' })),
      ]),
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' })),
      ]),
    ]),
  ],
})
export class RQ7Component implements OnInit {
  @Input() data: any;

  date;
  question;
  questions;
  userResponses = [];
  index;
  questionObj;
  messagetype;
  deviceWidth;
  user_bot = false;
  showbutton = true;
  public datemodel: any;
  disableDays: Array<IMyDate> = [];
  public myDatePickerOptions: IMyDpOptions;
  disableAfter: IMyDate;
  ans_date;
  timer;
  modalRef: BsModalRef;
  tableElements = [
    {
      thead: 'Move In',
      rowElements: [
        '$3.00',
        '$1.00',
        '$16.00',
        '$1.00',
        '$0.70',
        '$49.80',
        '$1.50',
      ],
    },
    {
      thead: 'Priority Move In',
      rowElements: [
        '$9.00',
        '$5.00',
        '$36.00',
        '$2.00',
        '$1.70',
        '$79.27',
        '$26.50',
      ],
    },
    {
      thead: 'Self-Select Switch',
      rowElements: [
        '$0.00',
        '$0.00',
        '$0.00',
        '$3.00',
        '$0.15',
        '$7.00',
        '$0.40',
      ],
    },
    {
      thead: 'Standard Switch',
      rowElements: [
        '$0.00',
        '$0.00',
        '$0.00',
        '$0.00',
        '$0.00',
        '$0.00',
        '$0.00',
      ],
    },
  ];
  thead;
  rowElements = [];
  tableIndex;
  providerContact: any;
  tduRates: any;
  private loadActualUtilityName = {
    AEPC: 'AEP Texas Central',
    AEPN: 'AEP Texas North',
    TNMP: 'Texas New Mexico Power',
    CNP: 'Centerpoint',
    ONC: 'Oncor',
    SHAR: 'Sharyland Utility',
    NUEC: 'NEC',
  };
  pickerValue: any;
  placeholderText = 'MM/DD/YYYY';
  inputView = 'web';
  hgHolidays = holidays.hgHolidays;
  myFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    return day !== 0 && day !== 6;
  };
  constructor(
    private residentialService: ResidentialService,
    private datePipe: DatePipe,
    private modalService: BsModalService,
    private ref: ChangeDetectorRef,
    private timeZoneService: AdjustTimeService
  ) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.deviceWidth = this.residentialService.deviceWidth;
  }
  minDate = this.timeZoneService.updateTime('America/Chicago');
  maxDate = new Date(new Date().setDate(new Date().getDate() + 60));
  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 0);
    }
  }

  ngOnInit() {
    this.residentialService.dateModel = '';
    this.residentialService.currentId = this.data;
    this.questions.map((row, i) => {
      if (row._id === this.data) {
        this.question = row.res_question;
        this.questionObj = row;
        this.index = i;
      }
    });

    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj))
      this.getDateObjectBasedOnUserResponses();

    this.messagetype = this.residentialService.messervicetype;
    if (this.deviceWidth < 768) this.inputView = 'mobile';
    this.getTduRatesForAllUtilityNames();
    this.thead = this.tableElements[0].thead;
    this.rowElements = this.tableElements[0].rowElements;
    this.tableIndex = 0;

    if (this.deviceWidth < 768) 
    {

    }else
    {
      if(!this.user_bot)
      {
        this.showbutton = false;
      }
  
    }
   
  }

  getDateObjectBasedOnUserResponses() {
    const obj = _.findWhere(this.userResponses, {
      res_question_id: this.questionObj._id,
    });
    if (!_.isEmpty(obj)) {
      this.date = obj.fieldValue;
      if (typeof this.date === 'string') {
        this.date = new Date(this.date);
      }
      this.datemodel = this.date;
      this.residentialService.dateModel = this.datemodel;
      this.ans_date = moment(new Date(this.datemodel))
        .format('MM/DD/YYYY')
        .toString();
      this.user_bot = true;
      if (this.deviceWidth < 768) {
        this.goNext();
      }
    }
  }

  getRealDay() {
    if (new Date().getDay() === 5) {
      return new Date().getDate() + 3;
    } else {
      var dd = _.filter(this.disableDays, {
        day: new Date().getDate(),
        month: new Date().getMonth() + 1,
      });
      return new Date().getDate();
    }
  }

  getTduRatesForAllUtilityNames() {
    this.residentialService
      .getTduIdForAllUtilityNames()
      .subscribe((res: any) => {
        this.tduRates = res;
        sessionStorage.setItem('tduRates', JSON.stringify(this.tduRates));
      });
  }

  pad(number) {
    return (number < 10 ? '0' : '') + number;
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-lg' })
    );
  }

  prevTab() {
    if (this.tableIndex > 0 || this.tableIndex === 0) {
      this.tableIndex = this.tableIndex - 1;
      this.rowElements = this.tableElements[this.tableIndex].rowElements;
      this.thead = this.tableElements[this.tableIndex].thead;
      this.ref.markForCheck();
    }
  }

  nextTab() {
    if (this.tableIndex < 4) {
      this.tableIndex = this.tableIndex + 1;
      this.rowElements = this.tableElements[this.tableIndex].rowElements;
      this.thead = this.tableElements[this.tableIndex].thead;
      this.ref.markForCheck();
    }
  }

  dateChanged(event) {
    this.datemodel = event;
    this.date = this.dateObjectCstFormatted();
    this.ans_date = moment(new Date(this.datemodel))
      .format('MM/DD/YYYY')
      .toString();
    this.user_bot = true;
    if (this.deviceWidth < 768) {
      this.goNext();
    }
  }

  next() {
    console.log(this.datemodel);
    if (!this.datemodel) {
    } else {
      const Obj = {
        res_question_id: this.data,
        fieldName: 'dateOfSwitch_ns',
        fieldValue: this.date,
      };
      this.residentialService.updateResponses(Obj);
      this.residentialService.messageService({ currentId: this.data });
    }
  }

  getActualUtilityName(utilName) {
    return this.loadActualUtilityName[utilName];
  }

  checkForWholeOrDecimal(number) {
    if (number == Math.floor(number)) {
      return `${number}.00`;
    } else {
      const newValue = number.toString();
      const newString =
        newValue.substring(newValue.indexOf('.') + 1).length >= 2
          ? newValue.substring(newValue.indexOf('.') + 1)
          : `${newValue.substring(newValue.indexOf('.') + 1)}0`;
      return `${newValue.substring(0, newValue.indexOf('.'))}.${newString}`;
    }
  }

  dateObjectCstFormatted() {
    return moment(new Date(this.datemodel))
      .format('YYYY-MM-DD')
      .toString();
  }

  valueChanged(event) {
    if (event) {
      this.datemodel = event.selectedValue;
      this.date = this.dateObjectCstFormatted();
      this.ans_date = moment(new Date(this.datemodel))
        .format('MM/DD/YYYY')
        .toString();
      this.user_bot = true;
      if (this.deviceWidth < 768) {
        this.goNext();
      }else
      {
        if(!this.showbutton)
        {
          this.next();
        }
      }
    }
  }
}
